import { render, staticRenderFns } from "./product-variant-holders.vue?vue&type=template&id=71744e25&scoped=true&"
import script from "./product-variant-holders.vue?vue&type=script&lang=ts&"
export * from "./product-variant-holders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71744e25",
  null
  
)

export default component.exports